import * as React from 'react';

function SvgHeartEmpty(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.1043 8.85648C22.0663 5.69697 19.4759 3.16556 16.3164 3.20022C14.7934 3.19482 13.3346 3.79334 12.2524 4.84699C11.1699 3.79334 9.70993 3.19481 8.17869 3.20018C5.02881 3.16556 2.43846 5.69697 2.40039 8.85648C2.39909 10.1589 2.84937 11.4137 3.67366 12.4125C3.73135 12.4805 5.1726 14.0941 7.72184 16.9463L11.754 21.4568C12.0198 21.7541 12.4852 21.7541 12.7509 21.4566L20.814 12.4324C21.6554 11.4137 22.1056 10.1589 22.1044 8.86389L22.1043 8.85648ZM12.7793 6.25772C13.6306 5.16757 14.9382 4.53243 16.3214 4.53728C18.7515 4.5107 20.7361 6.44895 20.7673 8.86889C20.7674 9.85148 20.4253 10.8035 19.7998 11.5614L12.2522 20.008L8.71672 16.0529C6.30513 13.3547 4.73775 11.5999 4.69868 11.5539C4.07862 10.8025 3.73651 9.84908 3.73746 8.86519C3.76658 6.45093 5.752 4.51068 8.1737 4.53725C9.56652 4.53243 10.8741 5.16757 11.7254 6.25772C11.9931 6.60049 12.5116 6.60049 12.7793 6.25772Z"
        fill="black"
      />
    </svg>
  );
}

export default SvgHeartEmpty;
